import { render, staticRenderFns } from "./EmpresaAdd.vue?vue&type=template&id=137201b7"
import script from "./EmpresaAdd.vue?vue&type=script&lang=js"
export * from "./EmpresaAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports